export enum CustomerAccountState {
    DoesNotExist = 0,
    AccountDisabled = 1,
    Interactive = 2,
    NotInteractive = 3,
    UnknownAccountError = 4,
}

export interface IVerifyEmailResponse {
    customerAccountState: CustomerAccountState;
}

export enum SignInPanels {
    Email = 1,
    Password = 2,
    SetPassword = 3,
    Validation = 4,
}
